import * as externalAuthReducer from "../reducers/externalAuthorizationReducer";
/* eslint-disable import/prefer-default-export */
export const { getMineEpicInfo } = externalAuthReducer;
